import React from 'react';
import PropTypes from 'prop-types';
import { Marker } from 'components/MapboxMap';
import { nanoid } from 'nanoid';
import { getAllLabelsFromArray } from '../utilities/getCentroidFromLatLon';

const getArrayOfLabels = geoCollection => {
  const fieldPoints = [];
  const cropZonePoints = [];
  const archivedPoints = {};
  const features = geoCollection?.features;
  features.forEach(item => {
    const isArchived = Boolean(item?.properties?.archived);
    if (item?.properties?.crop === undefined) {
      const fp = getAllLabelsFromArray(
        item?.geometry?.coordinates,
        item?.properties?.name ?? 'Untitled-Field'
      );
      fieldPoints.push({
        coordinates: fp[0],
        name: fp[1],
        isArchived
      });
    } else {
      const cp = getAllLabelsFromArray(
        item?.geometry?.coordinates,
        item?.properties?.name ?? 'Untitled-Cropzone'
      );
      cropZonePoints.push({
        coordinates: cp[0],
        name: cp[1],
        parentFieldId: item?.properties?.$parentFieldId
      });
    }
  });
  const results = {
    fieldPoints,
    cropZonePoints,
    archivedPoints
  };
  return results;
};
const objectMarkerLabelDefaultPropGeoCollection = [];
const ObjectMarkerLabel = ({
  geoCollection = objectMarkerLabelDefaultPropGeoCollection,
  activeObjectType = '',
  showOnlyArchived = false
}) => {
  const labelsArr = getArrayOfLabels(geoCollection);
  let markerPoints = [];
  if (activeObjectType === 'field' || activeObjectType === 'cropzone') {
    markerPoints = labelsArr.cropZonePoints;
  } else {
    markerPoints = labelsArr.fieldPoints;
  }

  if (geoCollection?.features?.length > 0) {
    let markerLabels = [];
    if (activeObjectType === 'farm' || activeObjectType === '') {
      markerLabels = markerPoints;
    } else {
      const mapFieldToCropZoneMarker = new Map();
      markerPoints.forEach(item => {
        const keyMap = `${item.parentFieldId}-${item.coordinates[0]}-${item.coordinates[1]}`;
        const mapItem = mapFieldToCropZoneMarker.get(keyMap);
        if (mapItem) {
          mapFieldToCropZoneMarker.set(keyMap, {
            ...mapItem,
            cropZoneNames: [...mapItem.cropZoneNames, item.name]
          });
        } else {
          mapFieldToCropZoneMarker.set(keyMap, {
            cropZoneNames: [item.name],
            ...item
          });
        }
      });
      markerLabels = [...mapFieldToCropZoneMarker.values()];
    }
    return markerLabels.map(marker => {
      return (
        <Marker
          key={nanoid()}
          coordinates={marker.coordinates}
          anchor="center"
          style={{
            pointerEvents: 'none'
          }}
        >
          <div
            data-tag="map-marker-children"
            className="flex flex-col items-center justify-center"
          >
            {!showOnlyArchived && (
              <div
                key={nanoid()}
                className="text-center self-center text-white font-bold text-lg"
              >
                {marker?.cropZoneNames?.map(name => (
                  <div
                    key={nanoid()}
                    data-tag="map-marker-cropzone"
                    className="my-1"
                  >
                    {name}
                  </div>
                )) ?? <div data-tag="map-marker-field">{marker.name}</div>}
              </div>
            )}
            {marker.isArchived && (
              <div
                data-tag="map-marker-field-archived"
                className="text-center self-center w-fit text-white rounded bg-neutral-80 px-1 py-0.5"
                style={{
                  marginTop: showOnlyArchived ? '0' : '4px',
                  borderRadius: '4px'
                }}
              >
                ARCHIVED
              </div>
            )}
          </div>
        </Marker>
      );
    });
  }
  return null;
};

ObjectMarkerLabel.propTypes = {
  geoCollection: PropTypes.shape({
    features: PropTypes.arrayOf(PropTypes.object)
  }),
  activeObjectType: PropTypes.string,
  showOnlyArchived: PropTypes.bool
};
export default ObjectMarkerLabel;
